<template>
  <div class="curriculum-course-choose" v-loading="isLoading">
    <div class="course-choose-title-container">
      <div class="course-choose-title">
        请选择您当前所选班级的科目,已选择<span class="course-count">{{
          selectedCourseNUmber
        }}</span
        >个科目。
      </div>
    </div>
    <div class="course-list-container">
      <div
        class="course-item-container"
        v-for="item in courseList"
        :key="item.courseId"
        v-if="item.courseName !== '总分'"
        :class="{ select: item.isSelect }"
        @click="chooseCourse(item)"
      >
        <img :src="$courseList[item.courseName]?$courseList[item.courseName].courseIcon:$courseList['其他'].courseIcon" class="course-icon" />
        <span class="course-name">{{ item.courseName }}</span>
        <div class="course-select-tag" v-show="item.isSelect">
          <i class="iconfont icon-complete icon" />
        </div>
      </div>
    </div>
    <div class="next-step-container">
      <button
        class="next-step-button"
        :disabled="selectedCourseList.length == 0"
        :class="{ 'not-selected': selectedCourseList.length == 0 }"
        @click="submitSelectedCourseList"
      >
        选择完毕，下一步
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      selectedCourseNUmber: 0,
      selectedCourseList: [],
      courseList: [],
      isLoading:false,
    };
  },
  created() {
    this.getCourseList();
  },
  methods: {
    getCourseList() {
      // console.log(this.classInfo);
      this.isLoading = true;
      this.get(this.$url.getCourseList, {
        schoolId: this.user.schoolId,
      }).then((res) => {
        // console.log("获取科目列表", res);
        if (res.rows === null){
          return this.$message.warning("暂无设置科目，请前往科目管理添加科目！");
        }
        if (res.code != 200) {
          return this.$message.error("获取科目列表失败！");
        }
        const curseListData = res.rows;
        curseListData.forEach((item) => {
          this.courseList.push({
            courseId: item.id,
            courseName: item.courseName,
            isSelect: false,
          });
        });
        this.isLoading = false;
      }).catch(err=>{
         return this.$message.error("获取科目列表失败！");
          this.isLoading = false;
      })
    },
    chooseCourse(courseItem) {
      Vue.set(courseItem, "isSelect", !courseItem.isSelect);
      this.filterChooseCourse();
    },
    filterChooseCourse() {
      let selectedCourseList = [];
      this.courseList.forEach((item) => {
        if (item.isSelect == true) {
          selectedCourseList.push({
            courseName: item.courseName,
            courseId: item.courseId,
            courseIcon: item.courseIcon,
          });
        }
      });
      this.selectedCourseList = selectedCourseList;
      this.selectedCourseNUmber = selectedCourseList.length;
    },
    submitSelectedCourseList() {
      this.$emit("submitSelectedCourseList", this.selectedCourseList);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./curriculumCourseChoose.scss";
</style>